import { useEffect } from "react";
import {
  reconcilePrimaryVoltageAndRating,
  type ReconcileArgs,
} from "./ReconcilePrimaryVoltageAndRating";

type ChangeInputValue = (e: { name: string; value: any }) => void;

/**
 * React hook that runs reconcilePrimaryVoltageAndRating whenever relevant
 * dependencies change, and dispatches any updates via changeInputValue().
 */
export function useReconcilePrimaryVoltageAndRating(
  args: ReconcileArgs,
  changeInputValue: ChangeInputValue,
) {
  useEffect(() => {
    const updates = reconcilePrimaryVoltageAndRating(args);
    for (const update of updates) {
      changeInputValue({ name: update.name, value: update.value });
    }
  }, [args, changeInputValue]);
}
